import React, { useEffect, useRef, useState } from "react";
import "../Style/dm.css";


import ServicesSection from "../components/Dmservices";
import RecSection from "../components/Dmrec";
import Dmfuturee from "../components/Dmfuture";
import Dmprocess from "../components/Dmprocess";
import Dmstack from "../components/Dmstack";
import Dmforms from "../components/Forms";
import DoubtSection from "../components/Dmdoubts";
import ClientFeedback from "../components/Clientfeedback";
import PageFooter from "../components/Footer";

function DmPage() {
  const overlayRef = useRef(null);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
          observer.disconnect();
        }
      },
      { threshold: 0.2 }
    );

    if (overlayRef.current) observer.observe(overlayRef.current);
    return () => observer.disconnect();
  }, []);

  return (
    <>
      {/* Hero Section */}
      <section className="dm-page">
        {/* CSS-only pattern layers, no images */}
        <div className="dm-grid-pattern" aria-hidden="true" />
        <div className="dm-blob dm-blob-1" aria-hidden="true" />
        <div className="dm-blob dm-blob-2" aria-hidden="true" />
        <div className="dm-blob dm-blob-3" aria-hidden="true" />

        <div
          className={`dm-overlay ${isVisible ? "dm-visible" : ""}`}
          ref={overlayRef}
        >
          <div className="dm-glass">
            {/* <img
              src={mpeoplesLogo}
              alt="MPeoples Logo"
              className="dm-logo dm-anim dm-anim-1"
            /> */}

            <span className="dm-eyebrow dm-anim dm-anim-2">
              Digital Marketing Services
            </span>

            <h1 className="dm-title dm-anim dm-anim-3">
              Result-Driven Digital Marketing Services That Grow Your Business
            </h1>

            <p className="dm-description dm-anim dm-anim-4">
              At MPeoples, we deliver data-driven digital marketing services that
              help businesses increase online visibility, generate qualified
              leads, and maximize ROI. From SEO and Google Ads to social media
              marketing, content marketing, and local SEO, our customized
              strategies drive measurable business growth across every digital
              channel.
            </p>

            
              <a href="tel:+919876543210"
              className="dm-btn dm-anim dm-anim-5"
            >
              Let&rsquo;s Build Together <span>↗</span>
            </a>
          </div>
        </div>
      </section>

      <ServicesSection />
      <RecSection />
      <Dmfuturee />
      <Dmprocess />
      <Dmstack />

      <Dmforms />
      <DoubtSection />
      <ClientFeedback />
      <PageFooter />
    </>
  );
}

export default DmPage;